// extracted by mini-css-extract-plugin
export default {"soldOutLabel":"_3mvgB","container":"_1xuhu"};